// Runtime configuration (loaded from public/config.js at runtime)
// Falls back to build-time env vars, then defaults
const runtimeScope = typeof window !== "undefined" ? window : {};
const config = runtimeScope.__RUNTIME_CONFIG__ || {};

const API_URL = config.API_URL || process.env.REACT_APP_API_URL || "http://localhost:8085/api";
const KEYCLOAK_CLIENT_ID = config.KEYCLOAK_CLIENT_ID || process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "le-prestige-hall-admin-ui";

module.exports = Object.freeze({
  ROOT_API_URL: API_URL,
  RESERVATIONS_ENDPOINT: "/reservations",
  ADMIN_RESERVATIONS_ENDPOINT: "/admin/reservations",
  APPOINTMENTS_ENDPOINT: "/appointments",
  ADMIN_APPOINTMENTS_ENDPOINT: "/admin/appointments",
  ADDONS_ENDPOINT: "/admin/add-ons",
  ADDON_CATEGORIES_ENDPOINT: "/admin/add-on-categories",
  PUBLIC_ADDONS_ENDPOINT: "/add-ons",
  ADMIN_PRICING_ENDPOINT: "/admin/pricing",
  ADMIN_PRICING_AUDIT_ENDPOINT: "/admin/pricing/audit",
  EVENT_ENDPOINT: "/events",
  FAQS_ENDPOINT: "/faqs",
  GALLERY_ENDPOINT: "/gallery",
  INVOICES_ENDPOINT: "/invoices",
  RECEIPT_ENDPOINT: "/admin/receipts",
  REVIEWS_ENDPOINT: "/reviews",
  ADMIN_CONTACT_ENDPOINT: "/admin/contact",
  USERS_ENDPOINT: "/users",
  ADMIN_USERS_ENDPOINT: "/admin/users",
  KEYCLOAK_CLIENT_ID: KEYCLOAK_CLIENT_ID,
});
